import { useMutation } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import { getLocalStorage } from '@/Utils/CommonUtils';

interface SelectedSlot {
  date: string;
  time: string;
}

interface RequestCallbackParams {
  selectedPlanType: 'personal' | 'group' | 'webinar';
  selectedDuration: number;
  selectedCoach: string; // coach tier code
  selectedSlots?: SelectedSlot[];
  tournamentId?: number;
  selectedPricing?: {
    level_slug?: string | null;
    level_name?: string | null;
    format_slug?: string | null;
    format_name?: string | null;
    coach_tier_code?: string | null;
  };
}

interface RequestCallbackResponse {
  success: boolean;
  request_id?: number;
  status?: string;
  message?: string;
}

export default function useRequestCallback(
  handleOnSuccess?: (data: RequestCallbackResponse) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<RequestCallbackResponse, Error, RequestCallbackParams>(
    async params => {
      const token = await getLocalStorage('access_token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      const response = await ChessRestClient.post<RequestCallbackResponse>(
        'subscription/v1/request-callback/',
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}

